module.exports = __webpack_public_path__ + "fonts/d961aea1/proxima_nova_bold-latin-a.woff2";